var $568f95594049d56e$exports = {};
$568f95594049d56e$exports = {
  "breadcrumbs": "Miez de p\xE2ine"
};
export { $568f95594049d56e$exports as default };